import { useMemo } from 'react';
import { useBoundaryIsCustom } from '~/store/boundaryGroups/boundaryGroups.selectors';
import { useGetBoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.selectors';
import { useBoundaryTerritoryDetailsSelector } from '../../../../store/boundaryTerritoryDetails/boundaryTerritoryDetails.selectors';
import { isDataLayersArtificialBoundaryTerritoryGroup } from '../../mapTools/dataLayersTool/dataLayersTool.helpers';

export const useBoundaryDetailsMarkersCount = (boundaryTerritoryGroupId: number, boundaryIds: number[]) => {
  const boundaryTerritoryDetails = useBoundaryTerritoryDetailsSelector();
  const { getBoundaryTerritoryGroupById } = useGetBoundaryTerritoryGroup();

  const relevantBoundaryDetails = boundaryTerritoryDetails.get(boundaryTerritoryGroupId);
  const boundaryTerritoryGroup = getBoundaryTerritoryGroupById(boundaryTerritoryGroupId);

  const boundaryIsCustom = useBoundaryIsCustom(boundaryTerritoryGroup?.boundaryGroupId);

  const markersCount = useMemo(() => {
    if (!relevantBoundaryDetails
      || (boundaryTerritoryGroup && isDataLayersArtificialBoundaryTerritoryGroup(boundaryTerritoryGroup)) // aritificial BTGs do not have counts guaranteed
      || (boundaryIsCustom && boundaryIds.length > 1) // custom boundaries can have overlaps, so we cannot guarantee that the counts are accurate using the method below
    ) {
      return null;
    }

    let markersSum = 0;

    for (const boundaryId of boundaryIds) {
      if (relevantBoundaryDetails.counts[boundaryId] !== undefined) {
        markersSum += relevantBoundaryDetails.counts[boundaryId] ?? 0;
      }
    }

    return markersSum;
  }, [relevantBoundaryDetails, boundaryTerritoryGroup, boundaryIds, boundaryIsCustom]);

  return {
    markersCount,
  };
};
